import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { SearchField, SearchFieldType } from './searchField';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';
import { SearchFilters } from './searchFilters';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { GlobalSearchRecord } from './GlobalSearchRecord';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  options = { authenticate: true, setRoot: true };

  constructor(private api: GatewayAPIService) {}

  getSearchFields(searchForm: string): SearchField[] {
    //getSearchFields(searchForm:string):Promise<SearchField[]>  {

    return [
      new SearchField({
        name: 'merchantName',
        displayName: 'Merchant Name',
        fieldType: SearchFieldType.TextBox,
      }),
      new SearchField({
        name: 'merchantContactName',
        displayName: 'Contact Name',
        fieldType: SearchFieldType.TextBox,
      }),
      new SearchField({
        name: 'merchantPostalCode',
        displayName: 'Postal Code',
        fieldType: SearchFieldType.TextBox,
      }),
      new SearchField({
        name: 'merchantStatus',
        displayName: 'Merchant Status',
        fieldType: SearchFieldType.DropDownList,
        selectItems: [
          new ListItem({ id: '-1', name: '(any)' }),
          new ListItem({ id: '2', name: 'Test' }),
          new ListItem({ id: '3', name: 'Active' }),
          new ListItem({ id: '1', name: 'Disabled' }),
        ],
      }),
      new SearchField({
        name: 'businessName',
        displayName: 'Business Name',
        fieldType: SearchFieldType.TextBox,
      }),
    ];
  }

  doOmniSearch(
    query: string,
    filters: SearchFilters,
    pagingData: any,
  ): Promise<Page<GlobalSearchRecord>> {
    return this.api
      .apiCallSane(
        '/globalsearch',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { q: query, filters, pagingData },
        this.options,
      )
      .then(
        (response: Partial<Page<GlobalSearchRecord>>) =>
          new Page<GlobalSearchRecord>(response),
      );
  }

  getPaged(
    query: string,
    data: any,
    filters: SearchField[] = [],
  ): Promise<Page<GlobalSearchRecord>> {
    data.q = query;
    data.filters = filters;

    return this.api
      .apiCallSane(
        '/globalsearch',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        data,
        this.options,
      )
      .then(
        (response: Partial<Page<GlobalSearchRecord>>) =>
          new Page<GlobalSearchRecord>(response),
      );
  }
}
